
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns804ec061f94b8512fbb52c9ae5ba133cen from './en.yaml'
            i18n.addResourceBundle('en', '804ec061f94b8512fbb52c9ae5ba133c', flattenObject(ns804ec061f94b8512fbb52c9ae5ba133cen), true, true);
        
        export default '804ec061f94b8512fbb52c9ae5ba133c';
    